export default "__VITE_ASSET__fbd551ce__"